/* eslint-disable */
function getCookie(name){  // eslint-disable-line no-use-before-define
  var pattern = RegExp(name + "=.[^;]*")
  var matched = document.cookie.match(pattern)
  if(matched){
    var cookie = matched[0].split('=')
    return cookie[1]
  }
  return false
}

export {getCookie}
/* eslint-enable */